import React, { Component } from "react";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { livemonitorSelector } from "store/selector";
import { messageAction } from "store/action";
import { connect } from "react-redux";
import { Button } from "modules/theme";
import ActionButtons from "./ActionButtons";
import Tip from "./Tip";
import { confirm } from "modules/theme";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import DynamicAgTableCustomFilterAgentState from "./DynamicAgTableCustomFilterAgentState";
ModuleRegistry.registerModules([
	ClientSideRowModelModule,
	SetFilterModule,
	MenuModule,
	ColumnsToolPanelModule,
	FiltersToolPanelModule,
]);

export class DynamicAgTable extends Component {
	constructor(props) {
		super(props);
		this.renderList = this.renderList.bind(this);
		this.getData = this.getData.bind(this);
		this.renderActions = this.renderActions.bind(this);
		this.columnList = [
			{ field: "name", headerName: "Agent" },
			{
				field: "state",
				headerName: "Status",
				//filter: 'agSetColumnFilter',
				filter: DynamicAgTableCustomFilterAgentState,
				//filterParams: ["logout","offline"],
				// filter: 'agMultiColumnFilter',
				cellRenderer: this.renderStatus,
			},
			{
				field: "humanTime",
				headerName: "Time Spent",
				//cellClass: this.cellClass,
				cellRenderer: this.cellClass,
				sortable: true,
				sortingOrder: ["desc", "asc"],
				sort: "asc",
			},
			{
				field: "actions",
				headerName: "Actions",
				cellRenderer: this.renderActions,
				minWidth: 50,
				maxWidth: 100,
				// floatingFilter: false,
			},
		];
		this.oldList = {};
	}
	shouldComponentUpdate(nextProps, nextState) {
		//
		if (this.api && nextProps.list) {
			let result = this.getData(nextProps.list);
			this.api.applyTransactionAsync(result, (result) => {
				//
			});
		}
		return false;
	}
	getData(list) {
		let result = {
			update: [],
			add: [],
			remove: [],
		};
		let currentId = this.shortUuid();
		for (const data of list) {
			if (data.id && this.oldList && this.oldList[data.id]) {
				result.update.push(data);
			} else {
				result.add.push(data);
			}
			this.oldList[data.id] = currentId;
		}
		for (const key in this.oldList) {
			if (Object.hasOwnProperty.call(this.oldList, key)) {
				if (this.oldList[key] != currentId) {
					result.remove.push({ id: key });
					delete this.oldList[key];
				}
			}
		}
		return result;
	}
	shortUuid() {
		return (
			"0000" + ((Math.random() * Math.pow(36, 4)) | 0).toString(36)
		).slice(-4);
	}
	getColumnConf(columnsConf) {
		return (
			columnsConf || {
				resizable: true,
				floatingFilter: true,
				sortable: true,
			}
		);
	}

	renderStatus(params) {
		let value = params.value;
		let chipColor;
		if (value === "Online") {
			chipColor = "green";
		} else if (value === "Logout") {
			chipColor = "red";
		} else if (value === "Offline") {
			chipColor = "dark";
		} else {
			chipColor = "yellow";
		}
		return (
			<Tip text={value}>
				<span className={`${chipColor}-box chips-common-style`}>
					{value}
				</span>
			</Tip>
		);
	}

	renderActions(params) {
		let _this = this;
		const { configProcessor } = this.props;
		let state = params.data && params.data.state ? params.data.state : "";
		let style = { verticalAlign: "middle" };
		if (state !== "Logout" && state !== "IVR" && state !== "Queue") {
			console.log(
				"received state",
				state,
				"params in render actions dynamicagtable"
			);
			//   style.display = "none";
			return (
				<ActionButtons style={{ justifyContent: "center" }}>
					<Tip text={`${"Logout"}`} key={`${""}`}>
						<Button
							btnStyle="link"
							onClick={() => {
								console.log(
									"params force logout ",
									params.data
								);
								confirm("Do you want to logout user?", {
									icon: "logout",
									showConfirmation2: false,
								}).then((e) => {
									configProcessor("forcelogout", params.data);
								});
							}}
							// icon={'user-minus'}
						>
							<span
								class="material-symbols-outlined"
								style={{ color: "red", fontSize: "20px" }}
							>
								power_settings_new
							</span>
						</Button>
					</Tip>
				</ActionButtons>
			);
		} else return null;
	}
	cellClass(params) {
		/* if( params.data && params.data.diff ) {
      if( params.data.diff > 1200 ) {
        return "bg-danger text-dark";
      }else if( params.data.diff > 900 ) {
        return "bg-warning text-dark";
      }else if( params.data.diff > 600 ) {
        return "bg-primary text-white";
      }else if( params.data.diff > 300 ) {
        return "bg-success text-dark";
      }else if( params.data.diff > 120 ) {
        return "bg-info text-dark";
      }else if( params.data.diff > 60 ) {
        return "bg-light text-dark";
      }else if( params.data.diff > 30  ) {
        return "bg-white text-dark";
      }
    }
    return "bg-white text-dark"; */
		let chipColor = "white";
		if (params.data && params.data.diff) {
			let diff = params.data.diff;
			if (diff > 1200) {
				chipColor = "red";
			} else if (diff > 900) {
				chipColor = "yellow";
			} else if (diff > 600) {
				chipColor = "blue";
			} else if (diff > 300) {
				chipColor = "green";
			} else if (diff > 120) {
				chipColor = "info";
			} else if (diff > 60) {
				chipColor = "transparent";
			}
		}
		return (
			<span className={`${chipColor}-box chips-common-style`}>
				{params.value}
			</span>
		);
	}
	getColumn(columns) {
		let columnDefs = [];
		if (columns && columns.length) {
			columns.map((column) => {
				column.minWidth = column.minWidth || 100;
				column.flex = column.flex || 1;
				column.filter = column.filter || true;
				column.maxWidth = column.maxWidth || 600;
				column.width = column.width
				column.sortable = column.sortable || true;
				column.sortingOrder = column.sortingOrder || undefined;

				columnDefs.push(column);
			});
		}
		return columnDefs;
	}
	getRowId(params) {
		return params.data.id;
	}
	renderList() {
		const { list } = this.props;
		let _this = this;
		if (list) {
			list.map((info) => {
				if (info.id) {
					_this.oldList[info.id] = "INIT";
				}
			});
		}
	}
	render() {
		const {
			columns,
			columnsConf = "",
			agStyle = { width: "100%", height: "100%;" },
			divStyle = { height: 400, borderRadius: "15px" },
			agClassName = "ag-theme-alpine",
			boxClassName = "ag-theme-alpine",
			list = [],
		} = this.props;
		let _this = this;

		let columnDefs = this.getColumn(this.columnList);
		let defaultColDef = this.getColumnConf();

		this.renderList();

		return (
			<div className={boxClassName} style={divStyle}>
				<AgGridReact
					style={agStyle}
					className={agClassName}
					onGridReady={(params) => {
						_this.api = params.api;
					}}
					animateRows={true}
					defaultColDef={defaultColDef}
					enableRangeSelection="true"
					rowData={list}
					getRowId={this.getRowId}
					rowSelection="multiple"
					suppressRowClickSelection="true"
					columnDefs={columnDefs}
				></AgGridReact>
			</div>
		);
	}
}
DynamicAgTable.contextTypes = {
	__: PropTypes.func,
};

const stateToProps = (state) => ({
	list: livemonitorSelector.getLiveDynamic(state, { key: "list" }),
	// state: livemonitorSelector.getLiveDynamic(state, { key: 'state' }),
});

const dispatchToProps = (dispatch) => ({
	emitSocketMessage: (type, messageData) => {
		dispatch(messageAction.emitSocketMessage(type, messageData));
	},
	configProcessor: (type, messageData) => {
		dispatch(messageAction.configProcessor(type, messageData));
	},
});
export default connect(stateToProps, dispatchToProps)(DynamicAgTable);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DynamicAgTable.js